import { useState } from "react";
import Image from "components/Elements/Image/Image";
import Icon from "components/Elements/Icon/Icon";
import AnimationContainer from "components/Reusable/AnimationContainer/AnimationContainer";
import { useContent } from "contexts/contentContext/contentContext";

import styles from "./styles.module.scss";

const ExampleElem = ({
  link,
  name,
  title,
  subTitle,
}: {
  link: string;
  name: string;
  title: string;
  subTitle: string;
}) => {
  const { getTextByKey } = useContent();

  const [hover, setHover] = useState(false);
  const handleOpenGallery = (link: string) => {
    window.open(link, "_blank").focus();
  };

  return (
    <div
      onClick={() => handleOpenGallery(link)}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
    >
      <AnimationContainer animationClassName={"fade-in"} animationOn={hover}>
        <div className={styles.hoverLayer}>
          <Icon name="zoom-plus" white /> {getTextByKey("view-profile-text")}
        </div>
      </AnimationContainer>
      <div className={styles.subject}>
        <span>{getTextByKey(title)}</span>
        <p>{getTextByKey(subTitle)}</p>
      </div>
      <Image
        name={"picker/" + name}
        ext="jpg"
        className={styles.exampleImage}
      />
    </div>
  );
};

export default ExampleElem;
